import { deleteJson, postJson, withValidate, withDone } from '@rad/utility/http';
export const createScorecardMeasure = (x) => withDone(withValidate(postJson(`/api/scorecards/${x.scorecard_id}/measures`, x)))();
export const updateScorecardMeasure = (x) => withDone(withValidate(postJson(`/api/scorecards/${x.scorecard_id}/measures/${x.id}`, x)))();
export const removeScorecardMeasure = (x) => withDone(deleteJson(`/api/scorecards/${x.scorecard_id}/measures/${x.id}`))();
